import axios from 'axios';
import { API_HOST } from '@/utils/constants/api';
import parseError from '@/utils/formatting/parse-error';
import t, { i18n } from '@/i18n';
import store from '../../store';
import qs from 'qs';

const request = axios.create({
  baseURL: `${API_HOST}/api/v1`,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  headers: {
    'Accept-Language': i18n.locale,
  },
});

request.interceptors.request.use((config) => {
  if (store.state?.auth?.publicAccess)
    config.headers['act-public-key'] = store.state?.auth?.publicAccess;

  if (store.state?.auth?.token) config.headers.Authorization = `Token ${store.state?.auth?.token}`;

  return config;
});

request.interceptors.response.use(
  (response) => {
    return response;
  },
  function (e) {
    if (e.response.status === 500) {
      store.dispatch('alert/showAlert', {
        type: 'error',
        text: t('Something went wrong, reload the page'),
      });
    }
    const err = parseError(e, { important: true });
    if (err) {
      // This one is quite problematic because totally not universal
      store.dispatch(
        'error/create',
        t(
          'You cannot edit this version of the estimate because you have already created an act for it. Delete an act or create a new version to continue editing.'
        )
      );
      return Promise.resolve();
    }

    return Promise.reject(e);
  }
);

export default request;
